/** Helpers for the two owners of a RedstoneSim (ServerWorld's server glue and the offline game). */
import type { EntityCount } from './sim';

interface Pos { x: number; y: number; z: number }

/** How many of `list` (feet positions, `half` wide, `h` tall) touch the box. */
function hits(list: Iterable<Pos>, half: number, h: number, x0: number, y0: number, z0: number, x1: number, y1: number, z1: number, wide?: (e: Pos) => number): number {
  let n = 0;
  for (const e of list) {
    const r = wide ? wide(e) / 2 : half;
    if (e.x + r > x0 && e.x - r < x1 && e.z + r > z0 && e.z - r < z1 && e.y < y1 && e.y + h > y0) n++;
  }
  return n;
}

export interface EntityLists {
  players: Iterable<Pos>;
  mobs: Iterable<Pos & { width?: number }>;
  items: Iterable<Pos>;
  carts?: Iterable<Pos>;
}

/** What stands in a box (pressure plates, tripwire, detector rails). */
export function countEntities(l: EntityLists, x0: number, y0: number, z0: number, x1: number, y1: number, z1: number): EntityCount {
  return {
    players: hits(l.players, 0.3, 1.8, x0, y0, z0, x1, y1, z1),
    mobs: hits(l.mobs, 0.3, 0.9, x0, y0, z0, x1, y1, z1, (m) => (m as { width?: number }).width ?? 0.6),
    items: hits(l.items, 0.125, 0.25, x0, y0, z0, x1, y1, z1),
    carts: l.carts ? hits(l.carts, 0.49, 0.7, x0, y0 - 0.2, z0, x1, y1 + 0.5, z1) : 0,
  };
}

/** Daylight detector reading for a day fraction (render/sky.ts: 0.25 noon, 0.75 midnight). */
export function sunSignal(time: number): number {
  return Math.max(0, Math.min(15, Math.round(15 * Math.cos((time - 0.25) * Math.PI * 2) + 0.2)));
}
